import React from 'react'
import galo from '../assets/gal-1.png' 
import galt from '../assets/gal-2.png' 
import galth from '../assets/gal-3.png' 
import galfr from '../assets/gal-4.png' 
import galfv from '../assets/gal-5.png' 
import divi from '../assets/divi.svg' 
const Gallery = () => {
  return (
    <>
   <div className='flex justify-end w-[70%]'>
   <div className='md:w-[20%] ml-11    dots-main hidden md:block lg:block'>
         <div className='flex my-2 '>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-2'></span>
           </div>
           <div className='flex my-3 ml-10 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           </div>
           <div className='flex my-1 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-1'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-6'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           </div>
           <div className='flex my-6 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           </div>
           <div className='flex my-2 ml-11'>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-2'></span>
           </div>
           <div className='flex '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-1'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-6'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           </div>
         
         </div>
         </div>

<div className='howit-main md:-mt-40' >
            <div className='howit-wrap'>
            <center>
                <h1 className='text-center pt-7 font-Open text-[24px] text-[#272C34] font-semibold '>Gallery</h1>
                <img src={divi} alt='divider' className='-mt-9' />
</center>
                   

                <div className='w-[80%] z-40 mx-auto'>

                <div className='grid grid-cols-1 gap-3 md:grid-cols-3 lg:grid-3'>
             <div className='  p-4 rounded'>
             <img src={galo} alt='img 1' className='w-full my-4' />
             <img src={galt} alt='img 1' className='w-full' />


             </div>
             
             <div className='  p-4 rounded'>
             <img src={galt} alt='img 1' className='w-full my-4' />
             <img src={galth} alt='img 1' className='w-full' />


             </div>
             
             <div className='  p-4 rounded'>
             <img src={galfr} alt='img 1' className='w-full my-4' />
             <img src={galfv} alt='img 1' className='w-full' />


             </div>
             
 
                </div>

                </div>


                </div>
                </div>
  

    </>
  )
}

export default Gallery